import React, { useEffect } from "react"
import MetaTags from "react-meta-tags"
import { isMobile } from "react-device-detect"
import { Redirect } from "react-router-dom"

const Home = () => {
  useEffect(() => {
    const loader = document.querySelector(".loader")
    if (loader) {
      loader.classList.add("loader--hide")
    }
  }, [])

  // Mobile users should skip the holding slide and go directly to login
  if (isMobile) {
    return <Redirect to="/login" />
  }

  // Holding slide route is now a redirect for all devices.
  // Laptop and mobile users should both skip the holding slide and go directly to login.
  return <Redirect to="/login" />
}

export default Home
